import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { trackButtonClick } from '../../services/analyticsService';

const Footer = () => {
  const [isOptedOut, setIsOptedOut] = useState(false);
  const [showOptOutConfirm, setShowOptOutConfirm] = useState(false);

  useEffect(() => {
    // Check current opt-out status
    const optOutStatus = localStorage.getItem('analytics_opt_out') === 'true';
    setIsOptedOut(optOutStatus);
  }, []);

  const handleOptOut = () => {
    trackButtonClick({
      id: 'analytics-opt-out-confirm',
      text: 'Opt Out',
      type: 'privacy',
      additionalData: { action: 'opt_out' }
    });
    
    localStorage.setItem('analytics_opt_out', 'true');
    setIsOptedOut(true);
    setShowOptOutConfirm(false);
    // Clear existing client ID to stop further tracking
    localStorage.removeItem('analytics_client_id');
    sessionStorage.removeItem('analytics_session_id');
  };

  const handleOptIn = () => {
    trackButtonClick({
      id: 'analytics-opt-in',
      text: 'Opt In',
      type: 'privacy',
      additionalData: { action: 'opt_in' }
    });
    
    localStorage.setItem('analytics_opt_out', 'false');
    setIsOptedOut(false);
    // Generate new client ID
    const newClientId = `client_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('analytics_client_id', newClientId);
  };

  return (
    <footer className="bg-stone-900 text-stone-300 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-start gap-3 text-left">
          <div className="text-sm">
            <p className="font-serif text-stone-100 text-base">Ryan's Homepage</p>
            <p className="mt-1 text-stone-400">© {new Date().getFullYear()} All rights reserved.</p>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            {!isOptedOut ? (
              <button
                onClick={() => {
                  trackButtonClick({
                    id: 'analytics-opt-out-button',
                    text: 'Opt Out of Analytics',
                    type: 'privacy'
                  });
                  setShowOptOutConfirm(true);
                }}
                className="text-xs text-stone-300 hover:text-white underline underline-offset-4"
              >
                Opt Out of Analytics
              </button>
            ) : (
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <span className="text-xs text-stone-400">Analytics disabled</span>
                <button
                  onClick={handleOptIn}
                  className="text-xs text-stone-100 hover:text-white underline underline-offset-4"
                >
                  Opt In
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Opt-out confirmation modal */}
      {showOptOutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md mx-4">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Opt Out of Analytics</h3>
              <button
                onClick={() => {
                  trackButtonClick({
                    id: 'opt-out-modal-close',
                    text: 'Close',
                    type: 'ui'
                  });
                  setShowOptOutConfirm(false);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              If you opt out, we will stop tracking your visits. This will help protect your privacy, 
              but you won't be able to help us improve the site through your usage data.
            </p>
            <div className="flex gap-3">
              <button
                onClick={handleOptOut}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm font-medium"
              >
                Opt Out
              </button>
              <button
                onClick={() => {
                  trackButtonClick({
                    id: 'opt-out-modal-cancel',
                    text: 'Cancel',
                    type: 'ui'
                  });
                  setShowOptOutConfirm(false);
                }}
                className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 text-sm font-medium"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
